<template>
  <div class="divUserDisplay">
    <java-title-widge title="畅想体验 Java 真项目" v-if="type === 'java'">
      <span class="title1"></span>
      <span class="title2"></span>
    </java-title-widge>
    <web-title-widge :title="title" v-if="type === 'web'">
      <span class="title3">{{ title1 }}</span>
      <span class="title2 title4">{{ title2 }}</span>
    </web-title-widge>
    <python-title-widge :title="title" v-if="type === 'python'">
      <span class="title3">{{ title1 }}</span>
      <span class="title2 title4">{{ title2 }}</span>
    </python-title-widge>
    <div class="temTabs">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane
          label
          :name="String(index)"
          v-for="(item, index) in displayData"
          :key="index"
        >
          <span
            slot="label"
            :class="{
              hoverColorBlue: hoverColor === 'blue',
              hoverColorOrange: hoverColor === 'orange',
              hoverColorLightBlue: hoverColor === 'lightBlue',
              hoverColorWeb: hoverColor === 'web',
              hoverColorPython: hoverColor === 'python',
            }"
            >{{ item.desc }}</span
          >
          <div class="tabCon conBoxModel">
            <div class="foodCon">
              <viewer
                :class="{
                  imgVideo: true,
                  appScroll: item.type === 'pc',
                  appScrolls: item.type === 'app',
                }"
                v-if="item.imgs.length > 0"
              >
                <swiper :options="swiperOption">
                  <template v-if="item.type === 'pc'">
                    <swiper-slide
                      class="1"
                      id="index"
                      v-for="(v, index) in item.imgs"
                      :key="index"
                      style="width:434px !important;height:341px !important"
                    >
                      <div class="imgBg">
                        <img
                          v-lazy="{
                            src: v,
                            loading: require('./../../../../../assets/wheelplanting.jpg'),
                          }"
                          class="imgPosition"
                        />
                      </div>
                    </swiper-slide>
                  </template>
                  <template v-else>
                    <swiper-slide
                      class="1"
                      id="index"
                      v-for="(v, index) in item.imgs"
                      :key="index"
                      style="width:316px !important;height:630px !important"
                    >
                      <div class="imgBgs">
                        <img
                          v-lazy="{
                            src: v,
                            loading: require('./../../../../../assets/wheelplanting.jpg'),
                          }"
                          class="imgPosition"
                        />
                      </div>
                    </swiper-slide>
                  </template>
                  <template>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div
                      class="swiper-button-prev"
                      slot="button-prev"
                      @click="listName('')"
                    ></div>
                    <div
                      class="swiper-button-next"
                      slot="button-next"
                      @click="listName('')"
                    ></div>
                  </template>
                </swiper>
              </viewer>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <display-button-widge
        :links="linkData"
        :btnHoverColor="btnHoverColor"
        :btnInitColor="btnInitColor"
        :lastUpdate="lastUpdate"
      ></display-button-widge>
    </div>
  </div>
</template>

<script>
import displayButtonWidge from "./displayButtonWidge";
import javaTitleWidge from "./../../java-v1/components/titleWidge";
import webTitleWidge from "./../../web/asserts/common/components/commonTitleWidge";
import pythonTitleWidge from "./../../python/components/titleWidge";
export default {
  components: {
    displayButtonWidge,
    javaTitleWidge,
    webTitleWidge,
    pythonTitleWidge,
  },
  data() {
    return {
      activeTab: "0", //前后台显示切换默认值
      showData: [],
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 26,
        slidesPerGroup: 2,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "swiper-button-disabled-class",
        },
      },
      title: "敢上线让用户体验的项目",
      title1: "才是",
      title2: "真项目",
    };
  },
  props: {
    displayData: {
      type: Array,
      default: () => [],
    },
    linkData: {
      type: Array,
      default: () => [],
    },
    hoverColor: {
      type: String,
      default: "blue",
    },
    btnHoverColor: {
      //鼠标悬浮之后的颜色
      type: String,
      default: "#0368d9",
    },
    btnInitColor: {
      //默认颜色
      type: String,
      default: "#0078ff",
    },
    type: {
      type: String,
      default: "java",
    },
    lastUpdate: {
      type: String,
      default: "",
    }
  },
  watch: {
    displayData() {
      this.$nextTick(() => {
        this.$parent.baseHeight = document.querySelector(
          ".divOffsetParent"
        ).offsetTop;
      });
    },
  },
  methods: {
    listName() {
      this.$trackEvent("左右切换", "点击", "左右切换");
    },
    handleClick() {
      this.$nextTick(() => {
        this.$parent.baseHeight = document.querySelector(
          ".divOffsetParent"
        ).offsetTop;
      });
    },
  },
};
</script>
<style lang="scss">
@import "./../scss/userDisplayWidge";
</style>
<style lang="scss" scoped>
.imgBg {
  width: 434px;
  height: 340px;
  background: #fff;
  border: none;
  border-radius: 5px;
  overflow: hidden;
}
.imgBgs {
  width: 316px;
  height: 630px;
  background: #fff;
  border: none;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 4px 14px 0px rgba(184, 184, 184, 0.77);
}
</style>
